module.exports = __webpack_public_path__ + "static/media/markus.339c2bde.png";